import React from 'react';
import {
  Modal,
  ModalDialog,
  Typography,
  Button,
  Box,
  Stack,
} from '@mui/joy';
import { Confetti as Celebration, SquaresFour as Dashboard } from '@phosphor-icons/react';

interface SetupCompleteModalProps {
  open: boolean;
  onClose: () => void;
  onGoToDashboard: () => void;
}

export const SetupCompleteModal: React.FC<SetupCompleteModalProps> = ({
  open,
  onClose,
  onGoToDashboard,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        variant="outlined"
        sx={{
          maxWidth: 450,
          textAlign: 'center',
          p: 4,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              backgroundColor: 'success.100',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Celebration size={40} color="var(--joy-palette-success-500)" />
          </Box>
        </Box>

        <Typography level="h3" sx={{ mb: 1 }}>
          You're All Set!
        </Typography>

        <Typography level="body-md" sx={{ color: 'neutral.600', mb: 3 }}>
          Congratulations! You've completed the Quick Setup wizard. Your ApexOS
          account is now configured and ready to help you manage your roofing
          business.
        </Typography>

        <Stack spacing={1.5}>
          <Button
            variant="solid"
            color="primary"
            size="lg"
            startDecorator={<Dashboard />}
            onClick={onGoToDashboard}
          >
            Go to Dashboard
          </Button>
          <Typography level="body-xs" sx={{ color: 'neutral.500' }}>
            You can always adjust your settings later
          </Typography>
        </Stack>
      </ModalDialog>
    </Modal>
  );
};

export default SetupCompleteModal;
